import {Directive, ElementRef, Input, OnInit, NgModule} from '@angular/core';
// import * as $ from "jquery";

@Directive({selector: '[image-error]'})
export class ImageError implements OnInit {

    @Input()
    url: string;

    constructor(private element: ElementRef) {
    }

    ngOnInit() {
        let img = $(this.element.nativeElement);
        // img.attr("src", "images/format_image.png");
        img.on('error', () => {
            //img.attr("src", "images/format_image.png");
            setTimeout(() => {
                img.attr("src", this.url);
            }, 1000)
        });
    }
}

@NgModule({
    declarations: [ImageError],
    exports: [ImageError]
})
export class ImageErrorModule {

}
